const assets = {
  moduleTitle: "الأصول",
  nav: {
    assetsAndDevices: "الأصول",
    assetTypes: "أنواع الأصول",
    assets: "الأصول",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
  },
  permissions: {
    core: "النواة",
    assetManagement: "إدارة الأصول",
    assetTypes: "أنواع الأصول",
    assets: "الأصول",
  },
  assetTypes: {
    list: {
      title: "أنواع الأصول",
      subtitle: "إنشاء أنواع الأصول المستخدمة في النظام والبحث فيها وإدارتها.",
    },
    stats: {
      total: "إجمالي الأصول",
      totalHint: "نوعاً مسجلاً",
      // بيانات ثابتة مؤقتاً حتى يضيف الخادم حقل isActive حقيقي -- انظر
      // التعليق في AssetTypesListScreen.
      active: "الأصول النشطة",
      activeHint: "جاهزة للاستعمال",
      inactive: "الأصول غير النشطة",
      inactiveHint: "معطلة مؤقتاً",
      loading: "جارٍ التحميل",
      error: "غير متاح",
    },
    toolbar: {
      add: "اضافة نوع أصل",
      archive: "الارشيف",
      search: "ابحث باسم نوع الأصل",
      searchPlaceholder: "بحث...",
    },
    status: {
      active: "نشط",
      inactive: "غير نشط",
    },
    table: {
      name: "اسم النوع",
      company: "الشركة",
      fieldsCount: "عدد الحقول",
      status: "الحالة",
      createdAt: "تاريخ الإنشاء",
      archivedAt: "تاريخ الأرشفة",
      empty: "لا توجد أنواع أصول مطابقة لهذا البحث.",
      error: "تعذر تحميل أنواع الأصول.",
      loading: "جارٍ تحميل أنواع الأصول",
      showing: "عرض {{count}} من {{total}}",
      rowsPerPageLabel: "عرض الصفوف",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "ترقيم الصفحات",
      sortAscending: "ترتيب تصاعدي",
      sortDescending: "ترتيب تنازلي",
      actionMenu: "إجراءات نوع الأصل",
    },
    actions: {
      view: "عرض",
      update: "تعديل",
      delete: "حذف",
      restore: "استعادة",
    },
    filters: {
      archivedAt: "تاريخ الأرشفة",
      archivedAtPlaceholder: "اختر نطاق تاريخ",
      clearDateRange: "مسح النطاق الزمني",
    },
    datePicker: {
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف نوع الأصل؟",
      warning: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      successFallback: "تم حذف نوع الأصل بنجاح.",
      errorFallback: "تعذر حذف نوع الأصل. يرجى المحاولة مرة أخرى.",
    },
    archived: {
      title: "أنواع الأصول المؤرشفة",
      subtitle: "أنواع الأصول التي تمت أرشفتها ويمكن استعادتها.",
      empty: "لا توجد أنواع أصول مؤرشفة مطابقة لهذه الفلاتر.",
    },
    detail: {
      title: "تفاصيل الشركة",
      companyName: "اسم الشركة",
      name: "اسم",
      notAvailable: "غير متاح",
      backToList: "الرجوع إلى أنواع الأصول",
    },
    restoreDialog: {
      title: "استعادة نوع الأصل",
      question: "هل أنت متأكد من استعادة نوع الأصل؟",
      prompt: "سيصبح نوع الأصل نشطاً مرة أخرى ويمكن استخدامه في النظام.",
      cancel: "الغاء",
      confirm: "استعادة نوع الأصل",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تمت استعادة نوع الأصل بنجاح.",
      errorFallback: "تعذرت استعادة نوع الأصل.",
    },
    form: {
      title: "اضافة نوع أصل",
      subtitle: "التفاصيل والمعلومات الأساسية.",
      createSuccessFallback: "تم إنشاء نوع الأصل بنجاح.",
      updateSuccessFallback: "تم تحديث نوع الأصل بنجاح.",
      editTitle: "تعديل نوع الأصل",
      editSubtitle: "تحديث تفاصيل نوع الأصل وإضافة حقول جديدة.",
      loading: "جارٍ تحميل نوع الأصل",
      loadError: "تعذر تحميل نوع الأصل.",
      empty: "تعذر العثور على نوع الأصل هذا.",
      generalInfo: "المعلومات الأساسية",
      company: "الشركة",
      companyPlaceholder: "اختر الشركة",
      companySearch: "بحث",
      companyEmpty: "لا توجد شركات.",
      nameAr: "الاسم بالعربي",
      nameEn: "الاسم بالانجليزي",
      description: "الوصف",
      optional: "(اختياري)",
      fieldsSection: "حقول الأصل",
      fieldNameAr: "اسم الحقل بالعربي",
      fieldNameEn: "اسم الحقل بالانجليزي",
      type: "النوع",
      required: "الزامي",
      unique: "غير متكرر",
      addField: "اضافة حقل",
      removeField: "حذف الحقل",
      uploadDocuments: "السماح برفع المرفقات لأصول هذا النوع",
      status: "نشط",
      statusDescription: "هل نوع الأصل هذا مستخدم حالياً.",
      toggleStatusDialog: {
        titleActivate: "تفعيل نوع الأصل",
        titleDeactivate: "إلغاء تفعيل نوع الأصل",
        questionActivate: "هل أنت متأكد أنك تريد تفعيل نوع الأصل هذا؟",
        questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل نوع الأصل هذا؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق نافذة تغيير الحالة",
      },
      fieldType: {
        string: "نص",
        number: "رقم",
        boolean: "نعم / لا",
        date: "تاريخ",
      },
      uniqueFieldRequired: "يجب تحديد حقل واحد على الأقل كحقل فريد.",
      duplicateFieldName: "اسم الحقل موجود بالفعل.",
      fieldNameTooLong: "يجب ألا يزيد عن {{count}} حرفاً.",
      fieldAutoFillNote:
        "سيتم تعبئة أصول هذا النوع الحالية تلقائياً بقيمة افتراضية لهذا الحقل.",
      saveFailed: "تعذر حفظ نوع الأصل. يرجى المحاولة مرة أخرى.",
      save: "حفظ",
      cancel: "الغاء",
    },
  },
  asset: {
    list: {
      title: "الأصول",
      subtitle:
        "تتبع كافة أصول الشركة المسجلة وفئاتها والأجهزة والبطاقات المرتبطة بها والوضع التشغيلي الفعلي لها.",
    },
    toolbar: {
      add: "اضافة أصل جديد",
      archive: "الارشيف",
      search: "ابحث باسم الأصل",
      searchPlaceholder: "بحث...",
    },
    filters: {
      filters: "الفلاتر",
      status: "الحالة",
      allStatuses: "كل الحالات",
      archivedAt: "تاريخ الأرشفة",
      archivedAtPlaceholder: "اختر نطاق تاريخ",
      clearDateRange: "مسح النطاق الزمني",
    },
    datePicker: {
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
    },
    attachments: {
      mainInformation: "المعلومات الأساسية",
      tabLabel: "المرفقات",
      addAttachments: "إضافة مرفقات",
      dropzoneTitle: "اسحب الملفات هنا أو انقر للاستعراض",
      dropzoneHint:
        "PDF، JPG، JPEG، PNG - بحد أقصى 25 ميجابايت لكل ملف و10 ملفات",
      browseFiles: "استعراض الملفات",
      addAnotherAttachment: "إضافة مرفق آخر",
      addAttachment: "إضافة مرفق",
      removeAttachment: "إزالة المرفق",
      attachmentPending: "بانتظار الرفع",
      fileSizeMb: "{{size}} ميجا",
      tooManyFiles: "يمكنك رفع حتى {{count}} ملفات كحد أقصى.",
      invalidType: "يُسمح فقط بملفات PDF وJPG وJPEG وPNG.",
      tooLarge: "يجب ألا يتجاوز حجم كل ملف 25 ميجابايت.",
    },
    status: {
      active: "نشط",
      inactive: "غير نشط",
    },
    table: {
      name: "اسم الأصل",
      code: "رمز الأصل",
      type: "نوع الأصل",
      company: "الشركة",
      status: "الحالة",
      archivedAt: "تاريخ الأرشفة",
      empty: "لا توجد أصول مطابقة لهذا البحث.",
      error: "تعذر تحميل الأصول.",
      loading: "جارٍ تحميل الأصول",
      showing: "عرض {{count}} من {{total}}",
      rowsPerPageLabel: "عرض الصفوف",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "ترقيم الصفحات",
      sortAscending: "ترتيب تصاعدي",
      sortDescending: "ترتيب تنازلي",
      actionMenu: "إجراءات الأصل",
    },
    actions: {
      view: "عرض",
      update: "تعديل",
      delete: "حذف",
      restore: "استعادة",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا الأصل؟",
      warning: "هذا الإجراء نهائي ولا يمكن التراجع عنه.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "الغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      successFallback: "تم حذف الأصل بنجاح.",
      errorFallback: "تعذر حذف الأصل. يرجى المحاولة مرة أخرى.",
    },
    archived: {
      title: "الأصول المؤرشفة",
      back: "العودة إلى الأصول",
      subtitle: "الأصول التي تمت أرشفتها ويمكن استعادتها.",
      empty: "لا توجد أصول مؤرشفة مطابقة لهذه الفلاتر.",
    },
    restoreDialog: {
      title: "استعادة الأصل",
      question: "هل أنت متأكد من استعادة هذا الأصل؟",
      prompt: "سيصبح هذا الأصل نشطاً مرة أخرى ويمكن استخدامه في النظام.",
      cancel: "الغاء",
      confirm: "استعادة الأصل",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تمت استعادة الأصل بنجاح.",
      errorFallback: "تعذرت استعادة الأصل.",
    },
    form: {
      title: "اضافة أصل",
      subtitle: "التفاصيل والمعلومات الأساسية.",
      generalInfo: "المعلومات الأساسية",
      branch: "الفرع",
      branchPlaceholder: "اختر الفرع",
      branchSearch: "بحث",
      branchEmpty: "لا توجد فروع.",
      company: "الشركة",
      companyPlaceholder: "اختر الشركة",
      companySearch: "بحث",
      companyEmpty: "لا توجد شركات.",
      assetType: "نوع الأصل",
      assetTypePlaceholder: "اختر نوع الأصل",
      assetTypeSearch: "بحث",
      assetTypeEmpty: "لا توجد أنواع أصول.",
      attributesSection: "تفاصيل الأصل",
      optional: "(اختياري)",
      invalidNumber: "أدخل رقماً صحيحاً.",
      tooShort: "يجب ألا يقل عن {{count}} حرفاً.",
      tooLong: "يجب ألا يزيد عن {{count}} حرفاً.",
      invalidFormat: "أدخل قيمة بالصيغة الصحيحة.",
      loadingFields: "جارٍ تحميل نموذج نوع الأصل...",
      loadFormError: "تعذر تحميل نموذج نوع الأصل هذا.",
      selectDatePlaceholder: "اختر تاريخاً",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
      createSuccessFallback: "تم إنشاء الأصل بنجاح.",
      saveFailed: "تعذر حفظ الأصل. يرجى المحاولة مرة أخرى.",
      save: "حفظ",
      cancel: "الغاء",
    },
    detail: {
      backToList: "العودة إلى الأصول",
      generalInfo: "المعلومات الأساسية",
      companyDetails: "تفاصيل الشركة",
      company: "الشركة",
      code: "رمز الأصل",
      branch: "الفرع",
      assetType: "نوع الأصل",
      assetName: "اسم الأصل",
      nameEn: "الاسم بالإنجليزية",
      nameAr: "الاسم بالعربية",
      notes: "ملاحظات",
      notAvailable: "غير متوفر",
      unanswered: "لم تتم الإجابة",
      yes: "نعم",
      no: "لا",
      attachments: "المرفقات",
      noAttachments: "لا توجد مرفقات حتى الآن.",
      loading: "جارٍ تحميل الأصل",
      loadError: "تعذر تحميل هذا الأصل.",
      empty: "تعذر العثور على هذا الأصل.",
    },
    edit: {
      title: "تعديل الأصل",
      subtitle: "تحديث حالة الأصل وتفاصيله.",
      backToDetail: "الرجوع إلى تفاصيل الأصل",
      status: "نشط",
      statusDescription: "التبديل بين كون هذا الأصل في الخدمة حالياً أم لا.",
      updateSuccessFallback: "تم تحديث الأصل بنجاح.",
      updateFailed: "تعذر تحديث الأصل. يرجى المحاولة مرة أخرى.",
      statusDialog: {
        titleActivate: "تفعيل الأصل",
        titleDeactivate: "إلغاء تفعيل الأصل",
        questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا الأصل؟",
        questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا الأصل؟",
        note: "لن يتم تطبيق هذا التغيير إلا بعد الحفظ.",
        yes: "نعم",
        no: "لا",
        close: "إغلاق نافذة تغيير الحالة",
      },
    },
  },
};

export default assets;
